module.exports = __webpack_public_path__ + "media/images/icons/vendors/large/eventhost-055fd5362a3ff07a21399405c15315f1.png";